exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v--modal-box[data-v-23d38264] {\n  height: auto !important;\n  background-color: white;\n}\n", ""]);

// exports
